import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyDataType = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="60%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Python – Data Types</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    In the previous chapter, we had learned about variables. In
                    this tutorial, we will discuss data types in Python
                    language. In Python programming, data types are inbuilt and
                    need not declare the type of a variable. Everything in
                    Python is an object, so data types are classes and variables
                    are known as an object.
                  </p>
                </div>
                <h1 className="py_h1">Numeric Types – int, float, complex</h1>
                <div className="col-md-4"></div>
                <div className="col-md-4">
                  <ul style={{ color: "white" }}>
                    <li>
                      <span style={{ fontWeight: "bold" }}>
                        Integer or int:{" "}
                      </span>{" "}
                      Integers are whole numbers and can be of any length.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>Float: </span>{" "}
                      Numeric value specified with a decimal point is known as
                      float.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>
                        Complex Number:{" "}
                      </span>
                      Complex numbers have a real and imaginary part, appending
                      with ‘j’ or ‘J’.
                    </li>
                  </ul>
                </div>
                <div className="col-md-4"></div>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <p>a=10</p>
                  <p>b=3.14</p>
                  <p>c=1 + 2j</p>

                  <p>
                    <span className="python-function">print</span>(a)
                  </p>
                  <p>
                    <span className="python-function">print</span>(b)
                  </p>
                  <p>
                    <span className="python-function">print</span>(c)
                  </p>
                </div>
                <p>
                  <span style={{ fontWeight: "bold" }}>type() – </span> We can
                  use type() function in python with one argument, to check the
                  type of variable or object.
                </p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Example</th>
                          <th scope="col">Command</th>
                          <th scope="col"> Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>a=10</td>
                          <td>
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(a))
                          </td>
                          <td> class 'int' </td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>b=3.14</td>
                          <td>
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(b)
                          </td>
                          <td>class ‘float’</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>c=1 + 2j</td>
                          <td>
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(c))
                          </td>
                          <td>class ‘complex’</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Boolean</h1>
                <hr style={{ color: "white" }} />
                <div>
                  <p>
                    <span style={{ fontWeight: "bold" }}>Boolean: </span>In
                    Python, the boolean type may have True or False value.
                    Capitalization of the first character is a must.
                  </p>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Example</th>
                          <th scope="col">Command</th>
                          <th scope="col"> Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>
                            a= <span className="python-function"> True </span>
                          </td>
                          <td>
                            <span className="python-function">print</span>(a) /
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(a))
                          </td>
                          <td> True / class ‘bool’ </td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>
                            {" "}
                            b= <span className="python-function"> False </span>
                          </td>
                          <td>
                            <span className="python-function">print</span>(b) /
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(b))
                          </td>
                          <td>False / class ‘bool’</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">String</h1>
                <hr style={{ color: "white" }} />
                <p>
                  {" "}
                  String: In Python, text values are stored as a string. It is a
                  sequence of characters, delimited with single or
                  double-quotes.
                </p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Example</th>
                          <th scope="col">Command</th>
                          <th scope="col"> Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>
                            a={" "}
                            <span className="python-string">
                              {" "}
                              'First String'{" "}
                            </span>
                          </td>
                          <td>
                            <span className="python-function">print</span>(a) /
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(a))
                          </td>
                          <td> First String / class ‘str’ </td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>
                            {" "}
                            b={" "}
                            <span className="python-string">
                              {" "}
                              "Second String"{" "}
                            </span>
                          </td>
                          <td>
                            <span className="python-function">print</span>(b) /
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(b))
                          </td>
                          <td>Second String / class ‘str’</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">
                  Sequence Data Type – list, tuple, range
                </h1>
                <hr style={{ color: "white" }} />
                <p>
                  {" "}
                  <span style={{ fontWeight: "bold" }}>List: </span> lists are
                  sequence type and may store the collection of different types
                  of data, it is mutable.
                </p>
                <p>
                  {" "}
                  <span style={{ fontWeight: "bold" }}>Tuple: </span> A tuple is
                  similar to a list, but it is immutable.
                </p>
                <p>
                  {" "}
                  <span style={{ fontWeight: "bold" }}>Range: </span> Range is
                  also an immutable type and commonly used for looping.
                </p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Example</th>
                          <th scope="col">Command</th>
                          <th scope="col"> Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>n=[10,20,30]</td>
                          <td>
                            <span className="python-function">print</span>(n) /
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(n))
                          </td>
                          <td> [10,20,30] / class ‘List’ </td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td> n=(1,2,3)</td>
                          <td>
                            <span className="python-function">print</span>(n) /
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(n))
                          </td>
                          <td>(1,2,3) / class ‘tuple’</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>
                            n= <span className="python-function">range</span>
                            (10)
                          </td>
                          <td>
                            <span className="python-function">print</span>(n) /
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(n))
                          </td>
                          <td>range(0, 10) / class ‘range’</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="bg-primary">
                  <p>
                    Note-: creating a list by placing all items inside a square
                    bracket [ ].
                  </p>
                  <p>
                    Note-: creating a tuple by placing all items inside a round
                    bracket ( ).
                  </p>
                  <p>Note-: creating a range using function.</p>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Set Data Types – set, frozenset</h1>
                <hr style={{ color: "white" }} />
                <p>
                  {" "}
                  <span style={{ fontWeight: "bold" }}>Set: </span> Set is a
                  collection of unique and unordered objects. It is mutable and
                  creates using a set() function.
                </p>
                <p>
                  {" "}
                  <span style={{ fontWeight: "bold" }}>Frozenset: </span>{" "}
                  Frozenset is also a collection of unique and unordered, but it
                  is immutable. We can create it using a frozenset() function.
                </p>

                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Example</th>
                          <th scope="col">Command</th>
                          <th scope="col"> Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>
                            x=<span className="python-function">set</span>(
                            <span className="python-string">"abacda"</span>)
                          </td>
                          <td>
                            <span className="python-function">print</span>(x) /
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(x))
                          </td>
                          <td> {("b", "c", "d", "a")} / class ‘set’ </td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>
                            x=<span className="python-function">frozenset</span>
                            (<span className="python-string">"abacda"</span>)
                          </td>
                          <td>
                            <span className="python-function">print</span>(n) /
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(n))
                          </td>
                          <td>
                            frozenset({("b", "c", "d", "a")}) / class
                            ‘frozenset’
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Mapping Data Types – dict</h1>
                <hr style={{ color: "white" }} />
                <p>
                  {" "}
                  <span style={{ fontWeight: "bold" }}>dict: – </span>A
                  dictionary is an unordered and mutable collection of objects,
                  and have keys and values. In Python, dictionaries are creating
                  using curly brackets {}.
                </p>

                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Example</th>
                          <th scope="col">Command</th>
                          <th scope="col"> Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>{"x = { one: 1, two: 2, three: 3 }"}</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>

                          <td> {"{'one': 1, 'two': 2, 'three': 3}"} </td>
                        </tr>
                        <tr>
                          <th scope="row"></th>
                          <td></td>
                          <td>
                            {" "}
                            <span className="python-function">print</span>
                            (x.keys())
                          </td>
                          <td>dict_keys([‘three’, ‘two’, ‘one’]) </td>
                        </tr>
                        <tr>
                          <th scope="row"></th>
                          <td></td>
                          <td>
                            {" "}
                            <span className="python-function">print</span>
                            (x.values())
                          </td>
                          <td> dict_values([3, 2, 1]) </td>
                        </tr>
                        <tr>
                          <th scope="row"></th>
                          <td></td>
                          <td>
                            {" "}
                            <span className="python-function">print</span>(
                            <span className="python-function">type</span>(x))
                          </td>
                          <td> class ‘dict’</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
